import { render, staticRenderFns } from "./CnabReturnsUploadList.vue?vue&type=template&id=afaf0484"
import script from "./CnabReturnsUploadList.vue?vue&type=script&lang=js"
export * from "./CnabReturnsUploadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports